import { useEffect } from 'react';
import { useState }  from 'react';

const useScreenSize = () => {
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setScreenSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const isXS = screenSize.width < 382;
    const isLG = screenSize.width > 992;

    return {
        screenSize,
        isXS,
        isLG,
    };
};

export default useScreenSize;